import { createSlice } from '@reduxjs/toolkit';
import { InvalidAddressType } from '../enums/invalidAddress';
import { InvalidAddressState } from '../types/state';

export const initialState: InvalidAddressState = {
  addressType: InvalidAddressType.ORIGINAL,
};

export const invalidAddressSlice: any = createSlice({
  name: 'invalidAddress',
  initialState,
  reducers: {
    setAddressType: (state, action) => {
      state.addressType = action.payload;
    },
  },
});

export const { setAddressType } = invalidAddressSlice.actions;

export default invalidAddressSlice.reducer;
